import { z } from "zod";

// Schema for raw cube data response from CSO cube
// Supports all three cost types (List, Billed, Effective)
export const costStatsRawDataSchema = z
  .array(
    z.object({
      "CSO.date.day": z.string(),
      "CSO.date": z.string(),
      "CSO.monthlyListSavingOpportunity": z.string().nullish(),
      "CSO.monthlyBilledSavingOpportunity": z.string().nullish(),
      "CSO.monthlyEffectiveSavingOpportunity": z.string().nullish(),
      "CSO.nonCompliantResourceCount": z.string(),
    }),
  )
  .nullish();
